var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoApproval24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_approval24x24",
    transform: "translate(-2.975 -5.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(2.975 5.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M12.255-2.321a.712.712,0,0,0-1,0L2.981,5.105-1.308,1.211a.983.983,0,0,0-1,0L-3.8,2.569a.569.569,0,0,0,0,.906l6.283,5.8a.712.712,0,0,0,1,0L13.751.033a.569.569,0,0,0,0-.906h0Z",
    transform: "translate(4.025 2.525)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoApproval24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_approval24x24.c69373bab9afb329cc3e999c0659fc5f.svg";